import React from 'react'
import Link from "gatsby-link";

class SuperchargeHome extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="Supercharge">
        <div className="internal">
          <h2>{this.props.title}</h2>
          <Link className="Btn orange-white" to="/buy">
            {this.props.callToAction}
          </Link>
        </div>
      </div>
    );
  }
}

export default SuperchargeHome;



// WEBPACK FOOTER //
// ./src/home/supercharge-cta-home.js